import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Code from './component/code';
import DataContext from './component/context/datacontext'; // Assuming DataContextProvider is your context provider component
import Home from './component/hero';
import Features from './component/feature'
function App() {
  return (
    <Router >
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route
          path="/editor"
          element={
            <DataContext>
              <Code />
            </DataContext>
          }
        />
        <Route path='/feature' element={<Features />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
